import { render, staticRenderFns } from "./TopNews.vue?vue&type=template&id=7e80352f&"
import script from "./TopNews.vue?vue&type=script&lang=js&"
export * from "./TopNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports